import { IRequirementDefinitionResponse } from "@wingspanhq/payments/dist/interfaces";
import { useUpdateBackgroundCheckSettings } from "../../../../../query/backgroundChecks/mutations/useUpdateBackgroundCheckSettings";
import { getBackgroundChecksDefaultValues } from "./getBackgroundChecksDefaultValues";

type Params = {
  dataSourceId: string;
};

export const useEditBackgroundChecksRequirementDefinition = ({
  dataSourceId
}: Params) => {
  const [updateSettings, updateSettingsMeta] =
    useUpdateBackgroundCheckSettings();

  const onSubmit = async (
    formValues: ReturnType<typeof getBackgroundChecksDefaultValues>
  ) => {
    await updateSettings(
      {
        instructions: formValues.instructions,
        dataSourceId
      },
      {
        throwOnError: true
      }
    );
  };

  return {
    onSubmit,
    ...updateSettingsMeta
  };
};
